// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"thankyouPageContent_contentWrapper__VykC5","title":"thankyouPageContent_title__3kkFz","infoText":"thankyouPageContent_infoText__h_BWu"};